import _ from "lodash";

let diffQues;
let midQues;
let easyQues;

export const getSpeedImgRecall = (questions, testType) => {
  // this condition means there may be demo or calibration test

  if (!!testType) {
    return [
      {
        info: questions[0].info,
        questionArray: dummyImgRecall(),
        info_audio: questions[0].info_audio,
        id: questions[0].id,
        resp_time: 50,
        test_id: questions[0].test_id,
        test_format: questions[0].test_format,
        score_count: "total",
        section_name: questions[0].section_name,
      },
    ];
  } else {
    if (questions.length === 1) {
      // this condition is because if parent component update twice
      return [questions[0]];
    } else {
      diffQues = getQues("diff", questions);
      midQues = getQues("mid", questions);
      easyQues = getQues("easy", questions);
      const questionArray = getAllQue();

      return [
        {
          info: questions[0].info,
          info_audio: questions[0].info_audio,
          questionArray,
          id: questions[0].id,
          resp_time: questions[0].resp_time,
          test_id: questions[0].test_id,
          test_format: questions[0].test_format,
          score_count: "total",
          section_name: questions[0].section_name,
        },
      ];
    }
  }
};

const getQues = (type, questions) => {
  let sortedQues;
  if (type === "diff") {
    sortedQues = questions.filter((ques) => ques.difficulty_level === "3");
  } else if (type === "mid") {
    sortedQues = questions.filter((ques) => ques.difficulty_level === "2");
  } else if (type === "easy") {
    sortedQues = questions.filter((ques) => ques.difficulty_level === "1");
  }
  return sortedQues;
};

const getEasy = (index) => {
  const question = easyQues.find((_, i) => i === index);
  return question;
};
const getMed = (index) => {
  const question = midQues.find((_, i) => i === index);
  return question;
};
const getDiff = (index) => {
  const question = diffQues.find((_, i) => i === index);
  return question;
};

const getAllQue = () => {
  let formattedArray = [];
  for (let i = 0; i < 10; i++) {
    const easy = getEasy(i);
    const med = getMed(i);
    const diff = getDiff(i);
    const easy2 = getEasy(i + 10);
    formattedArray = [...formattedArray, easy, med, diff, easy2];
  }
  return formattedArray;
};

const forDummyTest = [
  121,
  122,
  123,
  124,
  125,
  126,
  127,
  128,
  121,
  122,
  123,
  124,
  125,
  126,
  127,
  128,
];

const dummyImgRecall = () => {
  const sirArr = _.sampleSize(forDummyTest, 16);
  const data = sirArr.map((value) => {
    return { que_title1: `series${value}` };
  });
  return data;
};
